<template lang="pug">
.index
  //.dark-overlay
  .header
    p {{ typewriter.codenames.display }}
  .main-container
    .controls(v-if="!isJoinLobby")
      .create-lobby(@click="createLobby")
        p {{ typewriter.createNewLobby.display }}
      .join-lobby(@click="chooseJoinLobby")
        p {{ typewriter.joinExistingLobby.display }}
    .input-container(v-if="isJoinLobby")
      input#lobby-input(v-model="inputLobbyId", @keyup.enter="submitId")
      .enter(@click="submitId")
        p Join
      .cancel(@click="cancelJoinLobby")
        p Cancel
      .lobby-text
        p Enter Lobby ID
</template>

<script>
import * as firebase from "firebase/app";
import { nanoid } from "nanoid";
import animateWrite from "../helper/typewriter";

export default {
  data() {
    return {
      isJoinLobby: false,
      player: {
        id: "",
      },
      inputLobbyId: "",
      typewriter: {
        codenames: {
          data: "CodeNames",
          display: "",
          charIndex: 0,
        },
        createNewLobby: {
          data: "Create New Lobby",
          display: "",
          charIndex: 0,
        },
        joinExistingLobby: {
          data: "Join Existing Lobby",
          display: "",
          charIndex: 0,
        },
      },
    };
  },
  mounted() {
    window.x = this;
    this.player.id = nanoid();
    this.initWriteAnimations();
  },
  methods: {
    initWriteAnimations() {
      animateWrite(this.typewriter.codenames);
      animateWrite(this.typewriter.createNewLobby);
      animateWrite(this.typewriter.joinExistingLobby);
    },
    submitId() {
      this.$store.commit("setLobbyId", this.inputLobbyId);
      this.$router.push("/lobby");
    },
    createLobby() {
      const db = firebase.database();
      const lobbyId = nanoid(); // eslint-disable-line

      const updates = {};
      updates["/lobby/" + lobbyId] = {
        id: lobbyId,
      };
      db.ref().update(updates);
      this.$store.commit("setLobbyId", lobbyId);
      this.$router.push("/lobby");
    },
    chooseJoinLobby() {
      this.isJoinLobby = true;
    },
    cancelJoinLobby() {
      this.isJoinLobby = false;
    },
    test() {
      this.$store.commit("resetState");
    },
  },
};
</script>

<style scoped lang='sass' >
.index    
  position: fixed
  width: 100%
  height: 100%
  background-image: radial-gradient(orange, red, purple)

.main-container  
  position: absolute
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)

.join-lobby
  margin: 10px 0px
  cursor: pointer
  user-select: none
  width: 250px
  height: 40px
  display: flex
  justify-content: center
  align-items: center
  background-color: rgba(0, 0, 0, 0.7)
  color: #fff
  border: 1px solid #fff
  padding: 10px 0px

.create-lobby    
  margin: 10px 0px
  padding: 10px 0px
  cursor: pointer
  user-select: none
  width: 250px
  display: flex
  justify-content: center
  align-items: center
  background-color: rgba(0, 0, 0, 0.7)
  height: 40px
  color: #fff
  border: 1px solid #fff
  
.cancel
  background-color: rgba(0, 0, 0, 0.7)
  color: #fff
  border: 1px solid #fff
  width: 250px
  height: 35px
  text-align: center
  border-radius: 20px
  cursor: pointer
  user-select: none
  display: flex
  justify-content: center
  align-items: center
  padding: 0px
  margin: 10px 0px

.enter
  background-color: rgba(0, 0, 0, 0.7)
  color: #fff
  border: 1px solid #fff
  width: 250px
  height: 35px
  text-align: center
  border-radius: 20px
  cursor: pointer
  user-select: none
  display: flex
  justify-content: center
  align-items: center
  padding: 0px
  margin: 10px 0px

#lobby-input
  background: transparent
  color: #fff
  border: 1px solid #fff
  width: 250px
  height: 35px
  padding: 0px
  text-align: center
  border-radius: 20px
  outline: none
  margin: 10px 0px

.lobby-text    
  user-select: none

.dark-overlay    
  position: fixed
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, 0.5)

.header    
  padding-top: 40px
  font-size: 45px
  color: #fff
  text-transform: uppercase
  font-weight: bold
  letter-spacing: 7px
</style>
